import { Link } from '@hub/link';
import React from 'react';
import { useHeaderProps } from './header';
import { Logo } from '../logo';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderLogo = () => {
  const {
    logoLink: link,
    logoSlug: slug,
    logoLabel: label,
    onClickLogo: onClick,
    taskMode
  } = useHeaderProps();
  if (taskMode) {
    return /*#__PURE__*/_jsx(Logo, {
      variant: slug === 'gift-cards' ? slug : 'account',
      "data-id": "header_header-logo_HeaderLogo_Logo"
    });
  }
  const variant = slug === 'account' || slug === 'gift-cards' ? slug : slug ? 'centre' : 'national';
  if (!link) {
    return /*#__PURE__*/_jsx(Logo, {
      variant: slug ? 'centre' : variant,
      centreSlug: slug,
      "data-id": "header_header-logo_HeaderLogo_Logo_1"
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    href: link,
    onClick: onClick,
    ariaLabel: label,
    "data-id": "header_header-logo_HeaderLogo_Link",
    children: /*#__PURE__*/_jsx(Logo, {
      variant: variant,
      centreSlug: variant === 'centre' ? slug : undefined,
      "data-id": "header_header-logo_HeaderLogo_Link_Logo"
    })
  });
};